import React, { useState } from 'react';
import { auth, db } from '../firebase';
import { signInWithEmailAndPassword, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import logo from '../logo-assets/GIEPEI - COMPACTO-ok.png';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const checkAdminRoleAndNavigate = async (uid: string) => {
    const adminDoc = await getDoc(doc(db, 'admins', uid));
    if (adminDoc.exists() && adminDoc.data().role === 'admin') {
      navigate('/admin/dashboard');
    } else {
      await signOut(auth);
      setError('Acesso negado: Esta conta não tem privilégios de administrador.');
    }
  };

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      await checkAdminRoleAndNavigate(userCredential.user.uid);
    } catch (err: any) {
      console.error("Admin Login Error:", err.code);
      if (err.code === 'auth/invalid-credential') {
        setError('E-mail ou senha incorretos. Verifique se a conta existe e a senha está correta.');
      } else if (err.code === 'auth/too-many-requests') {
        setError('Muitas tentativas falhas. Tente novamente mais tarde.');
      } else {
        setError('Erro ao aceder ao painel: ' + err.code);
      }
    }
    setLoading(false);
  };

  const handleGoogleAdminLogin = async () => {
    const provider = new GoogleAuthProvider();
    setLoading(true);
    setError('');
    try {
      const result = await signInWithPopup(auth, provider);
      await checkAdminRoleAndNavigate(result.user.uid);
    } catch (err: any) {
      setError('Erro no login com Google: ' + err.message);
    }
    setLoading(false);
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <img src={logo} alt="GIEPEI" className="login-logo" />
        <h2>Painel Administrativo</h2>
        <p>Acesse com suas credenciais de gestor</p>

        <button onClick={handleGoogleAdminLogin} className="btn-google" style={{ marginBottom: '1.5rem', width: '100%' }}>
          Entrar com Google (Admin)
        </button>

        <div className="divider" style={{ margin: '1rem 0' }}><span>ou use email e senha</span></div>
        
        <form onSubmit={handleLogin}>
          <div className="form-group">
            <label>Email do Administrador</label>
            <input 
              type="email" 
              value={email} 
              autoComplete="username"
              onChange={(e) => setEmail(e.target.value)} 
              required 
              placeholder="admin@giepei.com"
            />
          </div>
          <div className="form-group">
            <label>Senha</label>
            <input 
              type="password" 
              value={password} 
              autoComplete="current-password"
              onChange={(e) => setPassword(e.target.value)} 
              required 
              placeholder="••••••••"
            />
          </div>
          {error && <p className="error-message">{error}</p>}
          <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
            {loading ? 'Validando...' : 'Entrar no Painel'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
